import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { fetchCounts } from "../services/ApiService";
import AboutPage from "./AboutPage";

const STAT_CARDS = [
  { label: "Solutions",  key: "devices",  accent: "#60a5fa" },
  { label: "Customers",  key: "hauliers", accent: "#34d399" },
  { label: "Vehicles",   key: "trucks",   accent: "#f472b6" },
];

const Home = () => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const loadCounts = async () => {
      try {
        const response = await fetchCounts();
        setCounts(response.data);
      } catch (error) {
        console.error("Failed to fetch counts", error);
      }
    };
    loadCounts();
  }, []);

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 3, mb: 3 }}>
        <Typography
          variant="h5"
          fontWeight={700}
          gutterBottom
          sx={{ color: "#0b1e3d", mb: 3 }}
        >
          Dashboard Overview
        </Typography>

        <Grid container spacing={3}>
          {STAT_CARDS.map(({ label, key, accent }) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: 3,
                  border: "1px solid #e2e8f0",
                  borderLeft: `4px solid ${accent}`,
                  background: "#fff",
                  transition: "box-shadow 0.2s ease, transform 0.2s ease",
                  "&:hover": {
                    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <CardContent sx={{ p: 2.5 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                      fontWeight: 600,
                      letterSpacing: "0.6px",
                      textTransform: "uppercase",
                      fontSize: "0.68rem",
                    }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 0.5,
                      fontSize: "2.2rem",
                      fontWeight: 700,
                      color: "#0b1e3d",
                      lineHeight: 1.2,
                    }}
                  >
                    {counts[key] ?? "—"}
                  </Typography>
                  <Box
                    sx={{
                      mt: 1,
                      height: 3,
                      width: 40,
                      borderRadius: 2,
                      background: accent,
                      opacity: 0.6,
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <AboutPage />
    </>
  );
};

export default Home;
